import { createContext } from 'react'

import type { LoginRequest, User } from '@/services/api/schemas/auth'

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous'

export interface AuthContextValue {
  status: AuthStatus
  /** null, если авторизация выключена флагом или пользователь ещё не загружен. */
  user: User | null
  login: (credentials: LoginRequest) => Promise<void>
  logout: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
